import { getAuthenticationState } from "auth/Authentication";

let _serverRoot: string | undefined = undefined;

export function setServerRoot(serverRoot: string) { _serverRoot = serverRoot; }

interface IDataActionConstants
{
	serverRoot: string,
	headers: HeadersInit
}

let constants: IDataActionConstants | undefined = undefined;

export function getDataActionConstants(): IDataActionConstants
{
	if (constants) return constants;

	const auth = getAuthenticationState();

	constants = {
		serverRoot: _serverRoot as string,
		headers: {
			'Authorization': `Bearer ${auth.token}`,
		}
	}

	return getDataActionConstants();
}